import {
    DIC
} from '@/const/dic'

export const productCouponOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    // menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "优惠券名称",
            prop: "couponName",
            type: "input",
            span: 24,
            formsolt: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入优惠券名称"
            }],
        },
        {
            label: '优惠券使用用户',
            prop: 'useCustomerType',
            formsolt: true,
            span: 24,
            type: "select",
            search: true,
            dicData: DIC.CLIENT_TYPE,
            rules: [{
                required: true,
                trigger: "change",
                message: "请选择优惠券使用用户"
            }],
        }
        // {
        //     label: '推广用户',
        //     prop: 'promoteCustomerType',
        //     type: "select",
        //     span: 24,
        //     dicData: DIC.CLIENT_TYPE,
        //     search: true,
        //     formsolt: true,
        // },
        // {
        //     label: '佣金比例',
        //     prop: 'commissionRate',
        //     formsolt: true,
        //     span: 24,
        // }
        , {
            label: '满多少减',
            prop: 'fullMoney',
            formsolt: true,
            hide: true,
            span: 24,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入满多少减"
            }],
        }, {
            label: '减多少',
            prop: 'deduction',
            formsolt: true,
            hide: true,
            span: 24,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入减多少"
            }],
        },
        {
            label: '商品品牌',
            prop: 'brandName',
            formsolt: true,
            hide: true,
            span: 24,
            rules: [{
                required: true,
                trigger: "change",
                message: "请选择商品品牌"
            }],
        },
        {
            label: '是否选择全分类优惠',
            prop: 'fullDiscount',
            formsolt: true,
            span: 24,
            // type: "radio",
            // dicData: DIC.YES_NO,
            hide: true
        },
        // {
        //     label: '产品售卖渠道',
        //     prop: 'productType',
        //     formsolt: true,
        //     span: 24,
        //     type: "select",
        //     hide: true,
        //     dicData: DIC.PRODUCT_ORDER_TYPE,
        //     rules: [{
        //         required: true,
        //         trigger: "change",
        //         message: "请选择产品售卖渠道"
        //     }],
        // },
        {
            label: '商品一级分类',
            prop: 'firstClassifyName',
            formsolt: true,
            span: 24,
            hide: true,
            rules: [{
                required: true,
                trigger: "change",
                message: "请选择商品一级分类"
            }],
        },
        {
            label: '商品二级分类',
            prop: 'secondClassifyName',
            formsolt: true,
            span: 24,
            hide: true,
            rules: [{
                required: true,
                trigger: "change",
                message: "请选择商品二级分类"
            }],
        },
        {
            label: '优惠券产品',
            prop: 'goodsId',
            span: 24,
            formsolt: true,
            hide: true
        },
        {
            label: '优惠券产品',
            prop: 'goodsName',
            viewVisdiplay: false,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '是否累计',
            prop: 'addUp',
            span: 24,
            formsolt: true,
            hide: true
        },
        {
            label: '是否累计',
            prop: 'addUp1',
            solt: true,
            viewVisdiplay: false,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '优惠券长期效期',
            prop: 'expiryDate',
            formsolt: true,
            span: 24,
            // type: "radio",
            //dicData: DIC.YES_NO,
            hide: true
        },
        {
            label: "开始时间",
            prop: "startTime",
            formsolt: true,
            span: 24,
            hide: true,
            rules: [{
                required: true,
                trigger: "change",
                message: "请选择开始时间"
            }],

        },

        {
            label: "结束时间",
            prop: "endTime",
            formsolt: true,
            span: 24,
            hide: true,
            rules: [{
                required: true,
                trigger: "change",
                message: "请选择结束时间"
            }],

        },
        {
            label: "开始时间",
            prop: "startTime1",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            viewVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "结束时间",
            prop: "endTime1",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            viewVisdiplay: false,
            editVisdiplay: false,
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false
        }

    ]
};